$('.social a').on('click', function(e){
		e.preventDefault();
		let features = 'width=640,height=480,location=no,toolbar=no,menubar=no',
				url = e.currentTarget.href,
				title = e.currentTarget.title;
		window.open(url, title, features);
});